import { jsx as _jsx } from "react/jsx-runtime";
import { Layout as AntdLayout } from "antd";
import { useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import { spacing } from "../../styles/spacing.js";
const { Content: AntdContent } = AntdLayout;
const Content = ({ children, minContentHeight })=>{
    const contentRef = useRef();
    const scrollBar = useMemo(()=>{
        return document.getElementById("scroll-progress");
    }, [
        children
    ]);
    const location = useLocation();
    useEffect(()=>{
        const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const listener = ()=>{
            const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            scrollBar.style.width = `${scrollTop / height * 100}%`;
        };
        window.removeEventListener("scroll", listener);
        window.addEventListener("scroll", listener);
    }, [
        children
    ]);
    useEffect(()=>{
        scrollBar.style.width = "0%";
    }, [
        location
    ]);
    useEffect(()=>{
        contentRef.current.scroll({
            top: 0
        });
    }, [
        location.pathname
    ]);
    return /*#__PURE__*/ _jsx(AntdLayout, {
        children: /*#__PURE__*/ _jsx(AntdContent, {
            ref: contentRef,
            onScroll: (event)=>{
                const height = Number(event.currentTarget.scrollHeight) - Number(event.currentTarget.clientHeight);
                const scrollTop = Number(event.currentTarget.scrollTop);
                scrollBar.style.width = `${scrollTop / height * 100}%`;
            },
            style: {
                padding: spacing.layout.content.padding,
                height: minContentHeight,
                overflow: "scroll"
            },
            children: children
        })
    });
};
export { Content };
